import { AppConfigService } from '../../../core/services/app-config/app-config.service';
import { AuthService } from '../../services/auth.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-logged-in',
	imports: [],
	templateUrl: './logged-in.component.html',
	styleUrl: './logged-in.component.scss',
})

export class LoggedInComponent {

	constructor(
		private router: Router,
		private authSvc: AuthService,
		private configSvc: AppConfigService
	) {
		this.authSvc.reachedLoggedInCallbackUrl();
		this.router.navigate([this.configSvc.settings.rootUrlPath]);
	}

}